import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="content-media-selector"
export default class extends Controller {
  static targets = ['audio', 'file', 'form', 'header', 'images', 'list', 'gmap', 'video', 'ai', 'scraper', 'text']

  connect() {
    document.addEventListener('contentTypeChanged', this.select.bind(this))
    this.hideAll()

    const contentTypes = this.constructor.targets
    const localType = localStorage.getItem('contentType')
    const contentType = contentTypes.includes(localType) ? localType : 'images'
    this[`${contentType}Target`].classList.remove('hide')
  }

  disconnect() {
    document.removeEventListener('contentTypeChanged', this.select.bind(this))
  }
  
  select(e) {
    this.hideAll()

    // this is being handled in content_type_selector
    // localStorage.setItem('contentType', e.target.value)
    // e.target.closest('label').classList.add('selected')
    // this[`${e.target.value}Target`].classList.remove('hide')

    this[`${e.detail.contentType}Target`].classList.remove('hide')
  }

  hideAll() {
    this.constructor.targets.forEach(target => this[`${target}Target`].classList.add('hide'))
  }
}